import { render, staticRenderFns } from "./stockDifference.vue?vue&type=template&id=96e9cc96&scoped=true"
import script from "./stockDifference.vue?vue&type=script&lang=js"
export * from "./stockDifference.vue?vue&type=script&lang=js"
import style0 from "./stockDifference.vue?vue&type=style&index=0&id=96e9cc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e9cc96",
  null
  
)

export default component.exports